<template>
  <div>
    <div class="payment__content" v-if="paySelectYn == true">
      <!-- header -->
      <div class="payment__header">
        <div class="lyr-title">{{ $t('User.PaySelect.msg1') }}</div>
        <div class="ft-point">{{ $t('User.PaySelect.msg2') }}</div>
        <div class="lyr-txt">{{ $t('User.PaySelect.msg3') }}</div>
      </div>
      <!-- //header -->
      <div class="payment__body">
        <div class="lst-order lst--xlg">
          <dl>
            <dt class="order-check">{{ $t('User.PaySelect.msg15') }}</dt>
            <dd class="order-check">{{ baskets.HEADER.ORDER_QTY }}</dd>
          </dl>
          <dl>
            <dt class="order-check">{{ $t('User.PaySelect.msg16') }}</dt>
            <dd class="order-check">{{ $displayUprc(baskets.HEADER.TOT_DC_AMT) }}</dd>
          </dl>
          <dl>
            <dt class="order-check">{{ $t('User.PaySelect.msg17') }}</dt>
            <dd class="order-check">{{ $displayUprc(baskets.HEADER.PAID_AMT) }}</dd>
          </dl>
          <dl>
            <dt class="order-check">{{ $t('User.PaySelect.msg18') }}</dt>
            <dd class="ft--3xlg ft--point">{{ $displayUprc(baskets.HEADER.SALES_AMT) }}</dd>
          </dl>
        </div>
        <div class="lst-box">
          <!-- one item -->
          <button class="touchbox touchbox--port btn-anim" @mouseup="payment('CASH', 'PAY01')" v-if="isSimpleToken && supportPayments.indexOf('PAY01') >= 0">
            <img src="@/assets/images/user/img-pay-cash.png" alt="" />
            <span class="txt">{{ $t('User.PaySelect.msg4') }}</span>
            {{}}
          </button>
          <!-- //one item -->

          <button class="touchbox touchbox--port btn-anim" @mouseup="payment('CARD', 'PAY03')" v-if="supportPayments.indexOf('PAY03') >= 0">
            <img src="@/assets/images/user/img-pay-card.png" alt="" v-if="isSimpleToken === true" />
            <img src="@/assets/images/user/img-pay-card-kr.png" alt="" v-else />
            <span class="txt">{{ $t('User.PaySelect.msg5') }}</span>
          </button>

          <button class="touchbox touchbox--port btn-anim" @mouseup="payment('CARD', 'PAY05')" v-if="!isSimpleToken && supportPayments.indexOf('PAY05') >= 0">
            <img src="@/assets/images/user/img-pay-card-kr.png" alt="" />
            <span class="txt">{{ $t('User.PaySelect.msg21') }}</span>
          </button>

          <button
            class="touchbox touchbox--port btn-anim"
            @mouseup="payment('EMONEY', 'EMONEY')"
            v-if="isSimpleToken && supportPayments.filter((payments) => emoneyList.indexOf(payments) >= 0).length > 0"
          >
            <img src="@/assets/images/user/img-pay-emoney.png" alt="" />
            <span class="txt">{{ $t('User.PaySelect.msg6') }}</span>
          </button>

          <button
            class="touchbox touchbox--port btn-anim"
            @mouseup="payment('QRPAY', 'QRPAY')"
            v-if="isSimpleToken && supportPayments.filter((payments) => qrpayList.indexOf(payments) >= 0).length > 0"
          >
            <img src="@/assets/images/user/img_pay_qr.png" alt="" />
            <span class="txt">{{ $t('User.PaySelect.msg7') }}</span>
          </button>

          <button
            class="touchbox touchbox--port btn-anim"
            @mouseup="payment('QRPAY', 'QRPAY')"
            v-if="!isSimpleToken && supportPayments.filter((payments) => kopayList.indexOf(payments) >= 0).length > 0"
          >
            <img src="@/assets/images/user/img_pay_qr_kr.png" alt="" />
            <span class="txt">{{ $t('User.PaySelect.msg7') }}</span>
          </button>

          <button class="touchbox touchbox--port btn-anim" @mouseup="emoneySelectYn = true" v-if="idleScreenExtrasType.split('')[0] == 1">
            <span class="txt" :class="{dark: darkModeYn}">{{ $t('User.PaySelect.msg11') }}</span>
          </button>
        </div>
      </div>
      <div class="layer__button">
        <button class="btn btn--cancel btn-anim" style="width: 100%" @mouseup="$emit('backPay')">{{ $t('User.PaySelect.msg19') }}</button>
      </div>
    </div>
    <Cash
      @closeCash="cashYn = false"
      @setCash="
        cashYn = false;
        cashReciptYn = true;
      "
      @setPayComplete="setPayComplete"
      @paymentError="paymentError"
      :totalUprc="baskets.HEADER.SALES_AMT"
      :tran="tranParam"
      v-if="cashYn == true"
    />
    <CashRecipt @closeCashRecipt="cashReciptYn = false" v-if="cashReciptYn == true" />
    <Members @membersClose="membersYn = false" :tran="tranParam" :barcodeType="members" v-if="membersYn == true" />
    <Barcode @closeBarcode="barcodeYn = false" v-if="barcodeYn == true" />
    <Emoney
      @paymentError="paymentError"
      @setPayComplete="setPayComplete"
      @closeEmoney="emoneyYn = false"
      v-if="emoneyYn == true"
      :totalUprc="baskets.HEADER.SALES_AMT"
      :tran="tranParam"
    />
    <QrCode
      @paymentError="paymentError"
      @setPayComplete="setPayComplete"
      :tran="tranParam"
      @closeQrCode="qrCodeYn = false"
      v-if="qrCodeYn == true"
      :totalUprc="baskets.HEADER.SALES_AMT"
    />

    <EmoneySelect
      @emCheck="
        emoneySelectYn = false;
        emoneyReadyYn = true;
        emoneyCheckYn = true;
      "
      @closeEmoneySelect="emoneySelectYn = false"
      @setEmoneyStatus="setEmoneyStatus"
      :emoneySelectYn="emoneySelectYn"
    />

    <EmoneyReady
      @emCheck="
        emoneyReadyYn = false;
        emoneyCheckYn = true;
        emoney = 1000;
      "
      @closeEmoneyReady="emoneyReadyYn = false"
      :emoneyReadyYn="emoneyReadyYn"
      :paymethod="paymethod"
    />
    <EmoneyCheck @closeEmoneyCheck="emoneyCheckYn = false" :emoney="emoney" :emoneyCheckYn="emoneyCheckYn" />
    <PaymentError @paymentError="paymentError" @closeModal="paymentErrorYn = false" v-if="paymentErrorYn" />

    <PayComplete @setPayComplete="setPayComplete" @setWineStage="setWineStage" :tranObj="tranObj" v-if="payCompleteYn" />

    <Card
      @closeCard="cardYn = false"
      @paymentError="paymentError"
      @setPayComplete="setPayComplete"
      @setInstalment="
        cardYn = false;
        instalmentYn = true;
      "
      :tran="tranParam"
      @setCard="
        cardYn = false;
        cardReturnYn = true;
      "
      :totalUprc="baskets.HEADER.SALES_AMT"
      v-if="cardYn == true"
    />

    <CardReturn @setPayComplete="setPayComplete" v-if="cardReturnYn" :totalUprc="baskets.HEADER.SALES_AMT" />

    <Instalment @closeInstalment="instalmentYn = false" :tran="tranParam" @setSign="setSign" v-if="instalmentYn" />
    <Sign
      @closeSign="
        signYn = false;
        instalmentYn = true;
      "
      @setPayComplete="setPayComplete"
      @paymentError="paymentError"
      :tran="tranParam"
      :instalmentNum="instalmentNum"
      :totalUprc="baskets.HEADER.SALES_AMT"
      @setSign="
        signYn = false;
        cardReturnYn = true;
      "
      @payment="payment('CARD', 'PAY03')"
      v-if="signYn"
    />

    <!-- 시음 토출 관련 팝업(1, 2, 3)) orderType 1-->
    <WineTasting v-if="wineTastingYn && wineOrderType == 1" :wineTran="wineTran" />

    <!-- 상품 반출 중 팝업(1, 2) orderType 2 -->
    <WineExport v-if="wineExportYn && wineOrderType == 2" :wineTran="wineTran" />

    <!-- 자동결제 -->
    <div class="dimed wrap" v-if="autoPaymentYn">
      <div class="layer layer--sm">
        <div class="layer__body">
          <div class="ft--xlg ft--bold">{{ $t('Modal.Payment.msg1') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cash from '@/components/modal/payment/Cash.vue';
import cashRecipt from '@/components/modal/payment/CashRecipt.vue';
import card from '@/components/modal/payment/Card.vue';
import cardReturn from '@/components/modal/payment/CardReturn.vue';
import members from '@/components/modal/payment/Members.vue';
import barcode from '@/components/modal/payment/Barcode.vue';
import emoney from '@/components/modal/payment/Emoney.vue';
import qrCode from '@/components/modal/payment/QrCode.vue';
import payComplete from '@/components/modal/payment/PayComplete.vue';
import axios from 'axios';
import audioHelper from '@/js/common/audioHelper.js';
import _ from 'lodash';
import paymentError from '@/components/modal/alert/PaymentError.vue';
import paymentFail from '@/components/modal/alert/PaymentFail.vue';

//할부
import instalment from '@/components/modal/payment/Instalment.vue';
//사인
import sign from '@/components/modal/payment/Sign.vue';

/* 전자 머니 */
import emoneySelect from '@/components/modal/EmoneySelect.vue';
import emoneyReady from '@/components/modal/EmoneyReady.vue';
import emoneyCheck from '@/components/modal/EmoneyCheck.vue';

import wineTasting from '@/components/modal/payment/WineTasting.vue';
import wineExport from '@/components/modal/payment/WineExport.vue';

export default {
  name: 'paymentSelect',
  props: {
    paySelectYn: Boolean,
    membersUseObj: Object,
  },
  methods: {
    //전자머니 준비
    setEmoneyStatus(paymethod) {
      this.emoneySelectYn = false;
      this.emoneyReadyYn = true;
      this.emoneyCheckYn = false;
      this.paymethod = paymethod;
    },
    //사인 준비
    setSign(instalmentNum) {
      this.instalmentYn = false;
      this.signYn = true;
      this.instalmentNum = instalmentNum;
    },
    //와인 출력 준비
    setWineStage(tran) {
      this.payCompleteYn = false;
      this.wineTran = tran;

      if (this.wineOrderType == 1 && this.orderType == 'F') {
        this.wineTastingYn = true;
      } else {
        this.wineExportYn = true;
      }
    },
    //결제 완료
    setPayComplete(tranObj) {
      let payType = tranObj.payType;

      this.$logInfo(`Payment Complete PayType : ${payType} Tran : ${JSON.stringify(tranObj)}`);

      if (payType == 'CASH') this.cashYn = false;
      else if (payType == 'CARD') {
        this.cardYn = false;
        this.cardReturnYn = false;
        this.signYn = false;
      } else if (payType == 'EMONEY') this.emoneyYn = false;
      else if (payType == 'QRPAY') this.qrCodeYn = false;
      else if (payType == 'MEMBERS') this.membersYn = false;
      else if (payType == 'ZERO') {
        this.autoPaymentYn = false;
        this.posTransactionYn = false;
      }
      this.tranObj = tranObj;
      this.payCompleteYn = true;
      //this.$router.replace({name: 'bell-select', params: {tran: JSON.stringify(tranObj)}});
    },
    //결제 오류
    paymentError() {
      this.paymentErrorYn = true;
      this.cardYn = false;
      this.cardReturnYn = false;
      this.signYn = false;
      this.emoneyYn = false;
      this.qrCodeYn = false;
      this.membersYn = false;
    },
    //결제 형식별 분기
    payment(payType, payMethod) {
      this.$logInfo(`Select Payment PayType : ${payType}`);
      this.$store.dispatch('clearIdle');

      // 결제 호출
      // 응답 값에 따다 로직 나누기 - 작업 전(코드 미결정)
      let tran = _.cloneDeep(this.baskets);
      tran.ITEMLIST.forEach((item) => {
        item.ITEM_NM = item.ORG_ITEM_NM;
        item.OPTIONITEM.forEach((item2) => {
          item2.ITEM_NM = item2.ITEM_ORG_NM;
        });
      });

      tran.PAYMENTLIST = [
        {
          SETTLE_TYPE: payType,
          PAYMENT_AMT: tran.HEADER.SALES_AMT,
          VAT_AMT: tran.HEADER.VAT_AMT,
          SETTLE_METHOD: payMethod,
        },
      ];
      this.tranParam = tran;
      if (payType == 'EMONEY') this.emoneyYn = true;
      else if (payType == 'QRPAY') this.qrCodeYn = true;
      else if (payType == 'CASH') this.cashYn = true;

      let cardSignYn = false;
      if (payType == 'CARD') {
        if (Number(this.tranParam.HEADER.SALES_AMT) >= 50000 && !this.isSimpleToken) {
          this.instalmentYn = true;
          cardSignYn = true;
        } else {
          this.cardYn = true;
          cardSignYn = false;
        }
      }

      if (payType != 'EMONEY' && payType != 'QRPAY' && !cardSignYn && payType != 'CARD' && payType != 'CASH') {
        if (payType == 'CASH') this.cashYn = true;
        else if (payType == 'MEMBERS') this.membersYn = true;
      }
    },

    //0원 결제 정보 전송
    zeroPaymentSend() {
      this.$logInfo(`Zero Pay auto payment Start`);
      this.$toggleProgressIcon(true);
      this.text = this.$t('Modal.Payment.msg1');
      this.param = {isZeroPay: !this.membersUseObj.IsPayComplete};
      let url = '/api/payment/sendpayment';
      this.instance
        .post(url, this.param)
        .then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Zero Payment Send Success`);
            this.zeroCompleteTran();
          } else {
            this.$toggleProgressIcon(false);
            this.posTransactionYn = true;
            this.tranUrl = '/api/payment/sendpayment';

            this.$logInfo(`Zero Payment Send Fail status : ${response.data.status} message : ${response.data.message}`);
          }
        })
        .catch((error) => {
          this.$toggleProgressIcon(false);
          this.posTransactionYn = true;
          this.tranUrl = '/api/payment/sendpayment';

          this.$logInfo(`Zero Payment Send axios Error : ${error}`);
        })
        .finally(() => {});
    },
    //0원 결제 완료
    zeroCompleteTran() {
      this.text = this.$t('Modal.Payment.msg2');

      //거래 완료
      let url = '/api/payment/completetran';
      this.instance
        .post(url, this.tran)
        .then((response) => {
          if (response.data.status == 0) {
            this.$logInfo(`Zero Complete Tran Success`);
            this.paymentEnd(response.data);
          } else {
            this.$toggleProgressIcon(false);
            this.posTransactionYn = true;
            this.tranUrl = '/api/payment/completetran';

            this.$logInfo(`Zero Complete Tran Fail status : ${response.data.status} message : ${response.data.message}`);
          }
        })
        .catch((error) => {
          this.$toggleProgressIcon(false);
          this.posTransactionYn = true;
          this.tranUrl = '/api/payment/completetran';

          this.$logInfo(`Zero Complete Tran axios Error : ${error}`);
        })
        .finally(() => {
          this.$toggleProgressIcon(false);
        });
    },
    //0원 결제 오류시 매출 트랜잭션 시작
    posTransactionNextStep(data) {
      this.posTransactionYn = false;
      if (this.tranUrl == '/api/payment/sendpayment') {
        this.zeroCompleteTran();
      } else {
        this.paymentEnd(data.data);
      }
    },
    //0원결제 완료
    paymentEnd(data) {
      let tranObj = {
        tranNo: data.data.tranNo,
        orderNo: data.data.orderNo,
        payType: 'ZERO',
        totalUprc: 0,
      };
      this.setPayComplete(tranObj);
    },
    zeroPaymentStart() {
      if (Number(this.membersUseObj.ReceivableAmount) == 0) {
        this.$store.dispatch('clearIdle');
        this.autoPaymentYn = true;
        this.zeroPaymentSend();
      }
    },
  },
  data() {
    return {
      instalmentNum: '00',
      savingList: [],
      emoneyYn: false,
      qrCodeYn: false,
      cashYn: false,
      cashReciptYn: false,
      cardYn: false,
      membersYn: false,
      barcodeYn: false,
      cardReturnYn: false,
      darkModeYn: this.$store.getters.getDarkModeYn,
      baskets: this.$store.getters.getBaskets,
      currUnitText: this.$store.getters.getCurrUnitText,
      emoneySelectYn: false, // 전자머니 선택
      emoneyReadyYn: false, // 전자머니 준비
      emoneyCheckYn: false, // 전자머니 완료
      emoney: 0, // 전자머니 금액
      paymentErrorYn: false,
      payCompleteYn: false,
      tranObj: '',
      tranParam: '',
      //결제 방법 종류
      supportPayments: this.$store.getters.getPosConfig.posConfig.supportPayments,
      isSimpleToken: this.$store.getters.getIsSimpleToken,
      instalmentYn: false, //할부
      signYn: false, // 사인
      emoneyList: ['PAY200', 'PAY201', 'PAY202', 'PAY203', 'PAY204', 'PAY205'],
      qrpayList: ['PAY19', 'PAY20', 'PAY64', 'PAY74', 'PAY75', 'PAY76', 'PAY77', 'PAY78', 'PAY79', 'PAY80'],
      kopayList: ['PAY19', 'PAY20', 'PAY14', 'PAY15', 'PAY16', 'PAY17', 'PAY18', 'PAY22', 'PAY23', 'PAY24'],
      idleScreenExtrasType: this.$store.getters.getPosConfig.posConfig.idleScreenExtrasType.toString(2).padStart(3, '0'),
      paymethod: '',
      orderType: this.$store.getters.getPosConfig.posConfig.templateNo,
      wineOrderType: this.$store.getters.getOrderType == 1 ? 1 : 2,
      wineTastingYn: false,
      wineExportYn: false,
      wineTran: null,
      autoPaymentYn: false,
      instance: axios.create({timeout: 300000}),
      posTransactionYn: false,
      text: '',
      tranUrl: '',
      param: null,
    };
  },
  mounted() {
    this.$showButtonAnimation();
  },
  updated() {
    this.$showButtonAnimation();
  },
  components: {
    Cash: cash,
    CashRecipt: cashRecipt,
    Card: card,
    Members: members,
    Barcode: barcode,
    CardReturn: cardReturn,
    Emoney: emoney,
    QrCode: qrCode,
    /* 전자머니 */
    EmoneySelect: emoneySelect,
    EmoneyReady: emoneyReady,
    EmoneyCheck: emoneyCheck,
    /* 결제 실패 */
    PaymentError: paymentError,
    PaymentFail: paymentFail,
    /* 결제 완료 */
    PayComplete: payComplete,
    /* 할부 */
    Instalment: instalment,
    /* 사인 */
    Sign: sign,
    WineTasting: wineTasting,
    WineExport: wineExport,
  },
  computed: {
    darkMode: function () {
      return this.$store.getters.getDarkModeYn;
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
    paySelectYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          if (this.membersUseObj != null) this.zeroPaymentStart();
          audioHelper.playAudio('00150', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    cashYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00151', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    cashReciptYn: function (val) {
      // try {
      //   // 20230407 HSSHIN Audio 재생
      //   if (val) {
      //     audioHelper.playAudio('00150', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
      //   }
      //   else {
      //     audioHelper.stopAudio();
      //   }
      // } catch (ex) {
      //   console.error(ex);
      // }
    },
    cardYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00152', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    cardReturnYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00153', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    barcodeYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00154', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
    membersYn: function (val) {
      try {
        // 20230407 HSSHIN Audio 재생
        if (val) {
          audioHelper.playAudio('00157', this.$i18n.locale, this.$store.getters.getPosConfig.posConfig.useVoiceSupport);
        } else {
          audioHelper.stopAudio();
        }
      } catch (ex) {
        console.error(ex);
      }
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/pages/payment.css" scoped></style>
<style src="@/assets/css/user/pages/touchbox.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style src="@/assets/css/user/dark/payment-dark.css" scoped></style>
.
<style src="@/assets/css/user/dark/touchbox-dark.css" scoped></style>
<style scoped>
.ico-checked {
  display: none;
}

.on > .ico-checked {
  display: block;
}
/* .payment__body {
  margin-top: 6vh;
} */
/* 
.lst-order {
  margin: 2vh auto;
} */
</style>
